import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  adminGetDashboardNewUsersDataApi,
  AdminDashboardNewUserStaticsResponseExt,
} from '../../../api/dashboard/adminGetDashboardNewUsersDataApi';
import { AdminDashboardDataFilterV2 } from '../../../graphql/API';

export const useAdminGetDashboardNewUsersDataQuery = (
  filter: AdminDashboardDataFilterV2,
): UseQueryResult<AdminDashboardNewUserStaticsResponseExt, Error> => {
  const adminGetDashboardQuery = useQuery({
    queryKey: ['admin-get-dashboard-new-users-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilterV2];
      const response = await adminGetDashboardNewUsersDataApi({ ...filter });
      return response;
    },
    enabled: !!filter.fromDate || !!filter.toDate,
  });
  return { ...adminGetDashboardQuery };
};
